// extracted by mini-css-extract-plugin
export default {"EditProfileForm":"EditProfile_EditProfileForm__m0vyL","EditProfileButton":"EditProfile_EditProfileButton__knDOa"};